const regExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function validateEmail(str) {
  const result = regExp.exec(str.toLowerCase().trim());
  return result && result[0];
}

export function emailDomain(str) {
  const result = regExp.exec(str.toLowerCase().trim());
  return result ? result.slice(-2)[0] : '';
}

export function emailLocalPart(str) {
  const domain = emailDomain(str);
  return domain ? str.slice(0, -1 - domain.length) : str;
}

export function getEmailErrorMessage(str) {
  if (str === '') return 'required';
  if (!validateEmail(str)) return 'email is invalid';
  return '';
}



// WEBPACK FOOTER //
// ./src/modules/signupForm/utils/email.js